<div class="info-card">
    <div class="header">
      
        <div class="header-left">
        <span class="title">{{ title }}</span>
        <ng-container *ngIf="badges?.length">
            <span
              class="badge"
              *ngFor="let badge of badges"
              [ngClass]="badge.class"
            >
              {{ badge.label }}
            </span>
          </ng-container>
      </div>
      
      <div class="header-right">
        <div class="actions" *ngIf="actions?.length">
            <button
              *ngFor="let action of actions"
              [disabled]="action.disabled"
              (click)="onActionClicked(action.name)"
              [ngClass]="action.class"
            >
              <app-svg-icon *ngIf="action.icon" [path]="action.icon" class="icon"></app-svg-icon>
            </button>
          </div>
      </div>

    </div>
  
    <div class="content">
      <ng-container *ngFor="let line of lines">
        <div class="line">{{ line }}</div>
      </ng-container>
    </div>
  </div>
  